exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box-shadow{-webkit-box-shadow:2px 2px 15px 0 rgba(0,0,0,.75);box-shadow:2px 2px 15px 0 rgba(0,0,0,.75)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-283dde35","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?outputStyle=expanded!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/routes/PageTemplates.vue
// module id = DPFn
// module chunks = 1